
export function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div>
            <h3 className="text-xl font-bold mb-4">奄美薬剤師会</h3>
            <div className="w-12 h-0.5 bg-amber-500 mb-6"></div>
            <div className="space-y-3 text-sm text-gray-300">
              <div className="flex items-start gap-2">
                <i className="ri-phone-line text-teal-400 mt-0.5"></i>
                <a href="tel:0997-53-3417" className="hover:text-teal-400 transition-colors">
                  0997-53-3417
                </a>
              </div>
              <div className="flex items-start gap-2">
                <i className="ri-mail-line text-teal-400 mt-0.5"></i>
                <a href="mailto:amamipa@gmail.com" className="hover:text-teal-400 transition-colors break-all">
                  amamipa@gmail.com
                </a>
              </div>
              <div className="flex items-start gap-2">
                <i className="ri-map-pin-line text-teal-400 mt-0.5"></i>
                <span>鹿児島県奄美市名瀬</span>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">リンク</h3>
            <div className="w-12 h-0.5 bg-amber-500 mb-6"></div>
            <ul className="space-y-3 text-sm">
              <li>
                <button onClick={scrollToTop} className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  ホーム
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  協会について
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  サービス
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('calendar')} className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  カレンダー
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  お問い合わせ
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">研修・学習</h3>
            <div className="w-12 h-0.5 bg-amber-500 mb-6"></div>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="#" className="text-gray-300 hover:text-teal-400 transition-colors">
                  学術講演会
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-teal-400 transition-colors">
                  集合研修の認定単位
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-teal-400 transition-colors">
                  JPAL
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-teal-400 transition-colors">
                  研修センター
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold text-teal-400 mb-4">学生の皆様へ</h3>
            <div className="w-12 h-0.5 bg-amber-500 mb-6"></div>
            <ul className="space-y-3 text-sm mb-6">
              <li className="flex items-center gap-2">
                <i className="ri-star-line text-amber-500"></i>
                <a href="#" className="text-gray-300 hover:text-teal-400 transition-colors">
                  キャリア情報
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-star-line text-amber-500"></i>
                <a href="#" className="text-gray-300 hover:text-teal-400 transition-colors">
                  研修プログラム
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-star-line text-amber-500"></i>
                <a href="#" className="text-gray-300 hover:text-teal-400 transition-colors">
                  見学申込
                </a>
              </li>
            </ul>
            <p className="text-xs text-gray-400 italic">
              未来の薬剤師を応援しています
            </p>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center gap-6">
              <p className="text-sm text-gray-400">
                &copy; 2025 奄美薬剤師会. All rights reserved.
              </p>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-gray-400 hover:text-teal-400 transition-colors"
              >
                Website Builder
              </a>
            </div>
            <div className="flex items-center gap-4">
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-slate-800 rounded-full hover:bg-teal-600 transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-slate-800 rounded-full hover:bg-teal-600 transition-colors cursor-pointer"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-slate-800 rounded-full hover:bg-teal-600 transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
